var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assignment-page-wrapper"},[_c('ProductContentAssignment',{attrs:{"contentData":_vm.contentData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }